import React from "react";
import { motion } from "framer-motion";
import SectionHeader from "../SectionHeader";

const VALUE_PROPS = [
  {
    icon: "🇮🇳",
    title: "Built for India",
    desc: "GST invoicing, TDS, e-way bills, and regional-language support come standard — not as afterthoughts.",
  },
  {
    icon: "🧩",
    title: "Modular by design",
    desc: "Start with the modules you need today and switch on more as you grow. No forced bundles.",
  },
  {
    icon: "⚡",
    title: "Fast onboarding",
    desc: "Guided data migration and role-based training get your team productive in weeks, not quarters.",
  },
  {
    icon: "🤝",
    title: "Support that answers",
    desc: "A real team in your timezone — phone, WhatsApp, and email — from kickoff to every busy season after.",
  },
];

const ValueProps = () => (
  <section className="section section--muted">
    <SectionHeader
      eyebrow="Why Byteflow"
      title="Software companies switch to, not from"
      lead="Four reasons growing businesses replace their patchwork of spreadsheets and legacy tools with Byteflow."
    />
    <div className="why-grid">
      {VALUE_PROPS.map((v, i) => (
        <motion.div
          key={v.title}
          className="why-card"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.45, delay: i * 0.07 }}
        >
          <div className="why-card__icon" aria-hidden>{v.icon}</div>
          <h3>{v.title}</h3>
          <p>{v.desc}</p>
        </motion.div>
      ))}
    </div>
  </section>
);

export default ValueProps;
